export default __webpack_public_path__ + "img/e82ae0f157b4cd490cb3b5089817ae2a.png";